export default __webpack_public_path__ + "static/bg-check-resource-blog-img-1cc93db59b30ec637aa7ea95e65ec4ac.jpg";